import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import useStyles from './styles';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import useQuery from 'custom_hooks/useQuery';
import MessageIncomingActions from '../../../../redux/reducers/message_incoming_reducer/actions';
import VatReturnsReceivedActions from '../../../../redux/reducers/vatreturns_received_list_reducer/actions';
import { ReducerKeys } from '../../../../redux/reducers';
import { getState } from 'redux/store';
import { StateStatus } from '../../../../redux/utils/common';
import { version } from 'os';
interface IProps {
  rowIndex: number;
  vat_return_received_id: string | number;
  error: string;
  incoming_message_id: string | number;
  vat_return_reference: string;
  total_msid_services: number;
  total_msid_goods: number;
  total_msest_services: number;
  total_msest_goods: number;
  total_corrections: number;
  grand_total: number;
  balance_of_vat_value: number;
  total_amount_to_be_reimbursed: number;
  total_amount_reimbursed: number;
  version: string;
  change_date: string;
}

export default function ActionsBlock(props: IProps) {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  // const query = useQuery();
  // const queryString =
  //   query && query.toString().length > 0 ? `?${query.toString()}` : '';
  // const vat_num = query.get('vat_num');
  // const msidCountry = query.get('msidCountry');
  // const schemeType = query.get('schemeType');
  // let searchParams = {
  //   ...(vat_num && { vat_num }),
  //   ...(msidCountry && { msidCountry }),
  //   ...(schemeType && { schemeType }),
  // };
  // console.log(searchParams);
  // console.log('>> ', query.toString());
  // let query = [];
  // if (data.vat_num)
  //   query.push({
  //     key: 'vat_num',
  //     value: data.vat_num,
  //   });
  // if (data.msidCountry)
  //   query.push({
  //     key: 'msidCountry',
  //     value: data.msidCountry,
  //   });
  // if (data.schemeType)
  //   query.push({
  //     key: 'schemeType',
  //     value: data.schemeType,
  //   });
  // let queryString = '';
  // query.map((query, index) => {
  //   if (index == 0) queryString += `?${query.key}=${query.value}`;
  //   else queryString += `&${query.key}=${query.value}`;
  // });

  const viewVatReturnReceivedDetails = async () => {
    const header = `Info for VAT Return ${props.vat_return_reference}`;
    await dispatch(
      VatReturnsReceivedActions.fetchPaymentReceivedDetailListAction({
        vatReferenceNumber: props.vat_return_reference,
        vatVersion: props.version,
      })
    );
    const paymentDetails = getState(
      ReducerKeys.VATRETURNS_RECEIVED_LIST_REDUCER
    ).PaymentReceivedDetailList.data;

    let total_vat_amount_paid = 0;
    Object.values(paymentDetails).forEach(
      (x: any) => (total_vat_amount_paid += x.vat_amount_received)
    );

    const data = {
      total_msid_services: props.total_msid_services,
      total_msid_goods: props.total_msid_goods,
      total_msest_services: props.total_msest_services,
      total_msest_goods: props.total_msest_goods,
      total_corrections: props.total_corrections,
      grand_total: props.grand_total,
      balance_of_vat_value: props.balance_of_vat_value,
      version: props.version,
      change_date: props.change_date,
      paymentDetails: paymentDetails,
      total_vat_amount_paid: total_vat_amount_paid,
      total_amount_to_be_reimbursed: props.total_amount_to_be_reimbursed,
      total_amount_reimbursed: props.total_amount_reimbursed,
    };
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_VAT_RETURN_RECEIVED_DETAILS_VIEW,
        params: { header, data },
      })
    );
  };

  const handleClick = async (type: 'view' | 'error') => {
    let header = type === 'view' ? 'XML Content' : 'XML Error';
    let body = type === 'view' ? props.incoming_message_id : props.error;

    if (type === 'view') {
      await dispatch(
        MessageIncomingActions.fetchMessageIncomingXmlAction({
          messageId: `${props.incoming_message_id}`,
        })
      );
      const xmlMessage = getState(
        ReducerKeys.MESSAGE_INCOMING_REDUCER
      ).xmlMessage;
      // console.log(xmlMessage);
      if (
        xmlMessage.status === StateStatus.Success &&
        xmlMessage.data !== null
      ) {
        body = xmlMessage.data;
      } else {
        body = `XML of Incoming Message with ID: ${props.incoming_message_id} not found`;
      }
    }

    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_VAT_RETURN_RECEIVED_XML_VIEW,
        params: { header, body },
      })
    );
  };

  return (
    <React.Fragment>
      <Button
        style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
        // variant="outlined"
        // className={classes.viewButton}
        onClick={() => viewVatReturnReceivedDetails()}
      >
        Info
      </Button>
      {props.incoming_message_id && (
        <Button
          style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
          // variant="outlined"
          // className={classes.viewButton}
          onClick={() => handleClick('view')}
        >
          XML
        </Button>
      )}
      {props.error && (
        <Button
          style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
          // variant="outlined"
          // className={classes.viewButton}
          className={classes.textRedColor}
          onClick={() => handleClick('error')}
        >
          Error
        </Button>
      )}
    </React.Fragment>
  );
}
